"use client";
import {
  useDialogStoreProps
} from "./QYS5FHDY.js";
import {
  useStore,
  useStoreProps
} from "./2GXGCHW6.js";
import {
  useUpdateEffect
} from "./Z32BISHQ.js";

// src/popover/popover-store.ts
import * as Core from "@ariakit/core/popover/popover-store";
function usePopoverStoreProps(store, update, props) {
  useUpdateEffect(update, [props.popover]);
  useStoreProps(store, props, "placement");
  return useDialogStoreProps(store, update, props);
}
function usePopoverStore(props = {}) {
  const [store, update] = useStore(Core.createPopoverStore, props);
  return usePopoverStoreProps(store, update, props);
}

export {
  usePopoverStoreProps,
  usePopoverStore
};
